import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PaginatedgetLabelCategoriesQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.LabelCategoriesFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PaginatedgetLabelCategoriesQuery = { labelCategories: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, label: string, name: string, icon?: { iconColor?: string | null, type: Types.IconTypeEnum, value: string } | null } }> | null } };


export const PaginatedgetLabelCategoriesDocument = /*#__PURE__*/ gql`
    query paginatedgetLabelCategories($sort: [SortType!], $filters: LabelCategoriesFilters, $first: Float, $after: String) {
  labelCategories(sort: $sort, filters: $filters, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        label
        name
        icon {
          iconColor
          type
          value
        }
      }
    }
    totalCount
  }
}
    `;

export function usePaginatedgetLabelCategoriesQuery(options?: Omit<Urql.UseQueryArgs<PaginatedgetLabelCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<PaginatedgetLabelCategoriesQuery, PaginatedgetLabelCategoriesQueryVariables>({ query: PaginatedgetLabelCategoriesDocument, ...options });
};